import React, {Component} from 'react';
import {connect} from 'react-redux';
import {expandRightMenu} from '../state/expandRightMenu';
import {setActiveButton} from '../state/activeButton';

class ListItemBar extends Component {
    constructor(props) {
        super(props);

        this.handleClick = e => {
            if (!e.target.classList.contains('fa-info-circle')) {
                let plusMinus = e.currentTarget.querySelector('i.fa-plus') || e.currentTarget.querySelector('i.fa-minus');
                let subList = e.currentTarget.nextSibling;
                let maxHeight = subList.childElementCount / 4 * (subList.firstElementChild.offsetHeight + 20) + 'px';
                if (subList.childElementCount / 4 < 1) {
                    maxHeight = (subList.firstElementChild.offsetHeight + 20) + 'px';
                }
                plusMinus.classList.toggle('fa-plus');
                plusMinus.classList.toggle('fa-minus');
                subList.style.maxHeight = subList.style.maxHeight !== '' ? '' : maxHeight;
                this.props.onClick();
            } else {
                this.props.expandRightMenu();
                this.props.setActiveButton({name: 'pomoc'});
                setTimeout(() => {
                    let ele = Array.from(document.getElementsByClassName(this.props.puzzle.class));
                    if (ele.length > 0) {
                        if (!this.props.isExpandedRightMenu) {
                                ele[0].scrollIntoView({behavior: 'smooth'});
                        } else {
                            ele[0].scrollIntoView({behavior: 'smooth'})
                        }
                    }
                }, 700)
            }
        };
    }

    render() {
        return (
            <div onClick={this.handleClick}>
                <p className="category-name-bar">
                    {this.props.category}
                </p>
                <p className="category-name-bar-icons">
                    <i className="fas fa-info-circle"/>
                    <i className={this.props.opened ? 'fas fa-minus plus-minus-span' : 'fas fa-plus plus-minus-span'}/>
                </p>
            </div>
        )
    }
}

export default connect(
    state => ({
        isExpandedRightMenu: state.expandRightMenu,
    }),
    {setActiveButton, expandRightMenu}
)(ListItemBar);



// WEBPACK FOOTER //
// ./src/LeftMenu/ListItemBar.js